var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheFooter',[_c('div',[_c('span',{staticClass:"ml-1"},[_vm._v("© 2020 PT. WESP Indonesia. "+_vm._s(_vm.version))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }